import React from "react";
import "./descriptionItem.less";

const DescriptionItem = ({ value, title, showTitle }) => {
   if (title === "-" || title === null || title === "") return null;
   return (
      <div className="gx-product-body-subtitle">
         <h6>
            {showTitle === true && <b>{title}: </b>}
            {value}
         </h6>
      </div>
   );
};

export default DescriptionItem;
